console.log("1")

async function decl(){
  console.log("2");
}

console.log("3");